import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IFormStepProps } from '../PageWrapper/PageWrapper';
import ResultScreen from '../../Components/ResultScreen/ResultScreen';
import Constants from '../../../Utils/Constants';
import ISessionManager from '../../../Business/ISessionManager';
import DI from '../../../Utils/DI';

const MsisdnUnderProgress: FC<IFormStepProps> = ({ nextStepHandler }) => {
    const { t } = useTranslation();
    const sessionManager: ISessionManager = DI.get('SessionManager');
    const isAgentLogged = useMemo(() => sessionManager?.getSession()?.getIsValid(), []);

    return (
        <ResultScreen
            title={t('error.validateStatus.isValid.title')}
            description={t('error.validateStatus.isValid.message')}
            actionText={t('validatePhoneNumber.reject')}
            success
            actionFn={() => {
                nextStepHandler(Constants.FORM_STEPS.ONBOARDING);
            }}
            showActionButton
        />
    );
};

export default MsisdnUnderProgress;
